module.exports = __webpack_public_path__ + "img/top-10-logo.8f5576cc.svg";